import React from 'react';

import { cloudinaryUrl } from '@/utils/utils';
import { MissingImage, useBrokenImage } from '@/stories/atoms/MissingImage/MissingImage';
import styles from './gallery-preview.module.css';
// import { useIsInView } from '@/hooks/useIsInView';

export type GalleryPreviewImageProps = React.ComponentProps<'button'> & {
  image: string,
  alt?: string,
  isFirst: boolean,
  isLast: boolean,
  nbImages: number,
  onClick: () => void
}

export const GalleryPreviewImage = ({ image, isFirst = false, isLast = false, alt = '', onClick, nbImages }: GalleryPreviewImageProps)=> {
  const { broken, ref, onError } = useBrokenImage()

  return (
    <button className={`${styles.wrapper} ${isFirst ? styles.first : '' } ${isLast ? styles.last : '' }`} onClick={onClick}>
      <span className='sr-only'>Agrandir l&apos;image</span>
      {isLast && <span className={styles.more}>+ {nbImages - 4}</span>}
      {broken ? (
        <MissingImage className={styles.image} variant={isFirst ? 'large' : 'default'}/>
      ) : isFirst ? (
         <img
          ref={ref}
          onError={onError}
          className={styles.image}
          loading="lazy"
          fetchPriority="high"
          width={343}
          height={273}
          sizes="
            (min-width: 75.375em) 570px,
            (min-width: 48em) calc((100vw - 32px)/2 - 16px),
            calc(100vw - 32px)
          "
          src={cloudinaryUrl({
            src: image,
            width: 570,
            crop: 'limit',
            params: ['h_456']
          })}
          srcSet={`
            ${cloudinaryUrl({src: image, width: 343, params: ['h_273']})} 343w,
            ${cloudinaryUrl({src: image, width: 570, params: ['h_570']})} 570w,
            ${cloudinaryUrl({src: image, width: 686, params: ['h_546']})} 686w,
            ${cloudinaryUrl({src: image, width: 1140, params: ['h_912']})} 1140w
          `}
          alt={alt}
        />
      ) : (
        <img
          ref={ref}
          onError={onError}
          className={styles.image}
          loading="lazy"
          width={343}
          height={343}
          sizes="
            (min-width: 48.0625em) 178px,
            calc(100vw - 32px)
          "
          src={cloudinaryUrl({
            src: image,
            width: 343,
            params: ['h_343']
          })}
          srcSet={`
            ${cloudinaryUrl({src: image, width: 178, params: ['h_178']})} 178w,
            ${cloudinaryUrl({src: image, width: 343, params: ['h_343']})} 343w,
            ${cloudinaryUrl({src: image, width: 356, params: ['h_356']})} 356w,
            ${cloudinaryUrl({src: image, width: 686, params: ['h_686']})} 686w
          `}
          alt={alt}
        />
      )}
    </button>
  )
};
